<template>
  <table border="1" cellpadding="10" cellspacing="0">
    <thead>
      <tr>
        <th v-for="item in columns">{{item.title}}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="trItem in data">
        <td v-for="tdItem in columns">
          <template v-if="tdItem.render">
            <span v-html="tdItem.render(trItem)"></span>
          </template>
          <template v-else="tdItem.render">{{trItem[tdItem.key]}}</template>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
export default {
  name: "qf-table",
  props: {
    columns: {
      type: Array,
      required: true
    },
    data: {
      type: Array,
      required: true
    }
  }
};
</script>
<style>
</style>